
<c-inspection-data
    :has-data    = "true"
    status       = "X"
    :show-header = "false"
    :height      = "height"
    :show-border = "true"
    :title       = "title"
>
    <template v-slot:body>
        <div class="w-100 h-100 " style="position: relative">
            <div
                v-if   = "!showCarousel"
            >
                <div
                    v-for = "(image, index) in images"
                    :key  = "index"
                    class = "responsive"
                >
                    <div class="gallery">
                        <c-inspection-image
                            :inspection-id = "image.inspectionId"
                            :image-id      = "image.image"
                        />
                    </div>
                </div>
            </div>

            <div v-if="showCarousel" :style="'max-height:' + height + 'px'">
                <v-carousel
                    v-model = "position"
                    :height = "height"
                    hide-delimiters
                    hide-delimiter-background
                    show-arrows-on-hover
                >
                    <v-carousel-item
                        class = "w-100"
                        style = "max-width: 100%"
                        v-for = "(item,i) in images"
                        :key  = "i"
                    >
                        <div class="gallery" style="position:relative;">
                            <div class="pl-1 pr-1" style="position: absolute; bottom: 5px; left: 5px; font-size: 12px; color: black; background-color: white">
                                {{ Math.round(item.size / 1024) }} KB
                            </div>
                            <img :src = "item.url" alt="" />
                        </div>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </div>

    </template>
</c-inspection-data>
